<section class="contacto" id="sContacto">
  <div class="contacto__container">
    <!-- Cabecera centrada -->
    <header class="contacto__header">
      <svg
        viewBox="0 0 100 100"
        width="46"
        height="52"
        class="contacto__hex"
        aria-hidden="true">
        <path
          d="M50 4 L93 27 L93 73 L50 96 L7 73 L7 27 Z"
          fill="none"
          stroke="var(--ts-primary)"
          stroke-width="6"
          stroke-linejoin="round"
          stroke-dasharray="10 7" />
        <text
          x="50"
          y="63"
          text-anchor="middle"
          font-size="38"
          fill="var(--ts-primary)"
          font-weight="700">
          &#64;
        </text>
      </svg>
      <h1 class="contacto__title">Cuéntanos qué necesitas</h1>
      <p class="contacto__sub">
        Escríbenos y te responderemos lo antes posible. Estaremos encantados de
        atenderte.
      </p>
    </header>

    <!-- Formulario en card -->
    <div class="contacto__card" appReveal>
      <span class="contacto__motivo-label" id="lbl-motivo">
        ¿De qué se trata?
      </span>
      <div class="segrow contacto__motivos" role="radiogroup" aria-labelledby="lbl-motivo">
        @for (m of motivos; track m.id) {
          <button
            type="button"
            class="seg"
            role="radio"
            [class.seg--active]="motivo() === m.id"
            [attr.aria-checked]="motivo() === m.id"
            (click)="pickMotivo(m.id)">
            {{ m.label }}
          </button>
        }
      </div>

      <form class="contacto__form" [formGroup]="form" (ngSubmit)="enviar()">
        <div class="contacto__grid2">
          <div class="contacto__field">
            <label for="contacto-name">Nombre *</label>
            <input
              id="contacto-name"
              type="text"
              formControlName="name"
              autocomplete="name"
              [class.is-invalid]="invalid('name')" />
          </div>
          <div class="contacto__field">
            <label for="contacto-phone">
              Teléfono <span class="contacto__optional">(opcional)</span>
            </label>
            <input
              id="contacto-phone"
              type="tel"
              formControlName="phone"
              autocomplete="tel" />
          </div>
        </div>

        <div class="contacto__field">
          <label for="contacto-email">Email *</label>
          <input
            id="contacto-email"
            type="email"
            formControlName="email"
            autocomplete="email"
            [class.is-invalid]="invalid('email')" />
          <span class="contacto__note">Te responderemos aquí.</span>
        </div>

        <div class="contacto__field">
          <label for="contacto-message">Mensaje *</label>
          <textarea
            id="contacto-message"
            rows="5"
            formControlName="message"
            [placeholder]="mensajePlaceholder()"
            [class.is-invalid]="invalid('message')"></textarea>
        </div>

        <label
          class="contacto__check"
          [class.is-invalid]="invalid('privacyAccepted')">
          <input type="checkbox" formControlName="privacyAccepted" />
          <span>
            He leído y acepto la
            <a
              href="#"
              (click)="$event.preventDefault(); showPrivacyModal = true">
              Política de Privacidad</a
            >.
          </span>
        </label>

        <p-button
          type="submit"
          label="Enviar mensaje"
          styleClass="w-full"
          size="large"
          [loading]="enviando" />
      </form>
    </div>

    <!-- Canales -->
    <div class="contacto__channels" appReveal>
      <a
        class="contacto__channel"
        href="mailto:{{ appConfig.business.email }}">
        <span class="contacto__channel-icon"><i class="ph ph-envelope"></i></span>
        <span class="contacto__channel-value">{{
          appConfig.business.email
        }}</span>
      </a>
      <a class="contacto__channel" href="tel:{{ appConfig.business.telephone }}">
        <span class="contacto__channel-icon"><i class="ph ph-phone"></i></span>
        <span class="contacto__channel-body">
          <span class="contacto__channel-value">{{
            appConfig.business.telephone
          }}</span>
          <span class="contacto__channel-sub">Laborables, 9:00–16:00</span>
        </span>
      </a>
    </div>

    <!-- Desvío a autoservicio -->
    <p class="contacto__selfservice">
      ¿Dudas sobre cómo funciona algo? En el
      <a routerLink="/ayuda">centro de ayuda</a> quizá esté ya respondido.
    </p>
  </div>

  <p-toast
    [breakpoints]="{ '640px': { width: '92vw', right: '4vw', left: '4vw' } }" />
</section>

<!-- Modal Política de Privacidad -->
<p-dialog
  [(visible)]="showPrivacyModal"
  header="Política de Privacidad"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '760px' }"
  [draggable]="false"
  [resizable]="false">
  @if (showPrivacyModal) {
    <app-politica-privacidad />
  }
</p-dialog>
